import { useQueryClient } from '@tanstack/react-query';

import { getThreadById } from '../../../../../shared/api/magellan/assistant';
import type { AssistantThread } from '../../../../../shared/entities/AssistantThread';
import type { AssistantUserMessage } from '../../../../../shared/entities/AssistantThreadMessage';
import { AssistantThreadMessageRole } from '../../../../../shared/entities/AssistantThreadMessage';

export function usePreviousThreadFilters(threadId?: number) {
  const queryClient = useQueryClient();
  const data = queryClient.getQueryData<AssistantThread>([
    getThreadById.name,
    threadId,
  ]);

  const userMessages = data?.messages.filter(
    message => message.role === AssistantThreadMessageRole.USER,
  );

  const lastUserMessage: AssistantUserMessage | undefined = userMessages?.[
    userMessages.length - 1
  ] as AssistantUserMessage;

  return lastUserMessage?.filters;
}
